import React, { Component } from "react";
import { DKLabel, DKButton } from "deskera-ui-library";

import RouteManager, { PAGE_ROUTES } from "../../managers/RouteManager";
import DataGridHolder from "../common/DataGridHolder";
import { TABLES } from "../../managers/TableManger";
import CampaignManager from "./CampaignManager";
import AppManager from "../../managers/AppManager";
import TemplateManager from "./templates/TemplateManager";

export default class Campaign extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  componentDidMount() {
    RouteManager.setPresenter(this);
  }

  render() {
    return (
      <div className="parent-width">
        <div className="column bg-deskera-secondary p-r border-radius-m border-m banner-holder">
          <DKLabel text='<span style="font-size:20px">🙋‍♂️</span> Need help getting started? Learn more about managing Campaigns.' />

          <div className="row mt-r ml-l">
            <DKButton
              className="border-m bg-white"
              title="Read"
              onClick={AppManager.showComingSoonWarning}
            />
            <DKButton
              className="border-m ml-r bg-white"
              title="Watch"
              onClick={AppManager.showComingSoonWarning}
            />
          </div>
        </div>
        <div className="column mt-l parent-width mb-xl position-relative ">
          <DataGridHolder
            tableName={TABLES.CAMPAIGN}
            allowRowEdit={true}
            allowSearch={true}
            allowFilter={true}
            allowColumnAdd={true}
            allowColumnEdit={true}
            onRowEdit={(data) => {
              let data_formatted = {};
              data_formatted.data = {
                _id: data.rowData.id,
                cells: data.rowData,
              };
              data_formatted.id = data.rowData.id;
              CampaignManager.setPageData(data_formatted);
              if (CampaignManager.checkCampaignInDraft()) {
                RouteManager.navigateToPage(
                  PAGE_ROUTES.CAMPAIGN_SUMMARY +
                    "/" +
                    CampaignManager.getCampaignId()
                );
              } else {
                RouteManager.navigateToPage(
                  PAGE_ROUTES.CAMPAIGN_BUILDER +
                    "/" +
                    CampaignManager.getCampaignId()
                );
              }
            }}
            allowRowAdd={true}
            addButtonConfig={{
              title: "+ New Campaign",
              className: "bg-app text-white",
              onClick: () => {
                CampaignManager.setPageData(null);
                TemplateManager.setSelectedTemplateId(null);
                RouteManager.navigateToPage(
                  PAGE_ROUTES.SELECT_CAMPAIGN_TEMPLATE
                );
              },
            }}
          />
        </div>
      </div>
    );
  }
}
